import React, { useEffect, useState } from 'react';
import useIncomingInvoiceRetailers from 'hooks/useIncomingInvoiceRetailers';
import PropTypes from 'prop-types';
import { Tooltip } from 'syngenta-digital-cropwise-react-ui-kit';

const IncomingInvoiceRetailerCard = ({ description }) => {
  const [firstThreeRetailers, setFirstThreeRetailers] = useState([]);
  const [tooltipRetailers, setTooltipRetailers] = useState([]);

  const { availableRetailers } = useIncomingInvoiceRetailers();

  useEffect(() => {
    if (availableRetailers?.length <= 3) {
      setFirstThreeRetailers(availableRetailers);
    } else {
      setFirstThreeRetailers(availableRetailers.slice(0, 3));
      setTooltipRetailers(availableRetailers.slice(3));
    }
  }, [availableRetailers]);

  return (
    <div className="p-4">
      <div
        data-testid="integrations-card-image-AgVend"
        className="m-auto pt-10 pb-10"
      >
        <div
          id="available-reatailers"
          className={`flex flex-row no-wrap w-full ${
            firstThreeRetailers.length > 1
              ? 'justify-between'
              : 'justify-center'
          }`}
        >
          {firstThreeRetailers?.map(retailer => (
            <div
              key={retailer.id}
              className={`flex justify-center items-center m-2 bg-white max-w-24 w-1/${firstThreeRetailers.length} h-36`}
              style={{ maxWidth: '132px' }}
            >
              <img
                src={`data:image/png;base64, ${retailer.thumb}`}
                alt={retailer.name}
                className="w-full"
              />
            </div>
          ))}
          {tooltipRetailers.length > 0 && (
            <Tooltip
              title={
                <ul className="list-none list-inside tooltip-list">
                  {tooltipRetailers.map(ret => (
                    <li key={ret.id} className="relative pl-4 pr-2">
                      {ret.name}
                    </li>
                  ))}
                </ul>
              }
              trigger="hover"
              color="#232630"
            >
              <div
                className="flex justify-center items-center m-2 bg-blue-10 text-blue-60 text-xl w-1/6 h-36 rounded-lg"
                data-testid="tooltip-retailers"
              >
                {`+ ${tooltipRetailers.length}`}
              </div>
            </Tooltip>
          )}
        </div>
      </div>
      <span
        data-testid="integrations-card-subtitle-AgVend"
        className="text-sm text-gray-800 leading-4"
      >
        {firstThreeRetailers.length > 1
          ? 'Import invoices from various retail portals in one submission, powered by AgVend.'
          : description}
      </span>
    </div>
  );
};

IncomingInvoiceRetailerCard.propTypes = {
  description: PropTypes.string.isRequired
};

export default IncomingInvoiceRetailerCard;
